import { useConnectModal } from '@rainbow-me/rainbowkit'
import { useCallback } from 'react'

/** Abre el modal nativo de RainbowKit (misma UX que WalletConnectButton). */
export function useOpenConnectModal(): () => void {
  const { openConnectModal } = useConnectModal()
  return useCallback(() => {
    openConnectModal?.()
  }, [openConnectModal])
}
